import React from "react";
import { ButtonRenderProps, ContentSection, Stack } from "sprint-common-web";

import { AncillaryComponentRenderer } from "../../../../../../common/components/AncillaryComponentRenderer";
import { MovieComponentRenderer } from "../../../../../../common/components/MovieComponentRenderer";
import { TvSeriesComponentRenderer } from "../../../../../../common/components/TvSeriesComponentRenderer";
import { isCloudAssetDeprecated, isInPreparation } from "../../../CloudAssetDetails";
import { useCloudAssetDetails } from "../../../common/hooks/useCloudAssetDetails";
import { CloudAncillaryContentSection } from "./ancillary/CloudAncillaryContentSection";
import {
    BulkEditCloudAssetContentButton,
    BulkEditCloudAssetContentButtonProps
} from "./edit/bulk/BulkEditCloudAssetContentButton";
import {
    EditCloudAssetContentButton,
    EditCloudAssetContentButtonProps
} from "./edit/single/EditCloudAssetContentButton";
import { CloudMovieContentSection } from "./movie/CloudMovieContentSection";
import { CloudTvSeriesContentSection } from "./tv-series/CloudTvSeriesContentSection";

export const CloudContentSection = (): JSX.Element => {
    const { isLoading, data: assetDetails } = useCloudAssetDetails();

    const contentSubtype = assetDetails?.content?.subtype;

    const isEditDisabled =
        assetDetails && (isCloudAssetDeprecated(assetDetails) || isInPreparation(assetDetails) || isLoading);

    const editContentButton: ButtonRenderProps<EditCloudAssetContentButtonProps> = {
        render: EditCloudAssetContentButton,
        disabled: isEditDisabled
    };

    const bulkEditContentButton: ButtonRenderProps<BulkEditCloudAssetContentButtonProps> = {
        render: BulkEditCloudAssetContentButton,
        disabled: isEditDisabled
    };

    const buttons = [editContentButton, bulkEditContentButton];

    if (isLoading || !assetDetails)
        return (
            <Stack>
                <ContentSection header="Content" isLoading={isLoading} style={{ height: 450 }} />
            </Stack>
        );

    return (
        <Stack>
            <ContentSection header="Content" isLoading={isLoading} style={{ height: 450 }} buttons={buttons}>
                <MovieComponentRenderer subtype={contentSubtype}>
                    <CloudMovieContentSection assetDetails={assetDetails} />
                </MovieComponentRenderer>
                <TvSeriesComponentRenderer subtype={contentSubtype}>
                    <CloudTvSeriesContentSection assetDetails={assetDetails} />
                </TvSeriesComponentRenderer>
                <AncillaryComponentRenderer subtype={contentSubtype}>
                    <CloudAncillaryContentSection assetDetails={assetDetails} />
                </AncillaryComponentRenderer>
            </ContentSection>
        </Stack>
    );
};
